module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/19_370ff94f5cb21d03a4953527bf3af08c.jpg";